// キャリア面談スケジュール編集画面（admin / career-consultant-portal 共通で利用する）

const CONSULTATION_MINUTES = 60
const OVERLAP_ALERT_CLASSES = ['border-red-500', 'ring-2', 'ring-red-500', 'bg-red-50']

/**
 * 対面指導日程一覧のJSON文字列をパースする
 *
 * @param {HTMLElement} container
 * @returns {Array<{
 *     started_at: string,
 *     ended_at: string,
 * }>}
 */
const parse_online_lesson_ranges = (container) => {
    try {
        return JSON.parse(container.getAttribute('data-online-lesson-ranges') || '[]')
    } catch (error) {
        return []
    }
}

/**
 * 選択した面談開始日時が、対面指導日程のいずれかと重複するか判定する
 *
 * @param {string} started_at_value
 * @param {Array<{
 *     started_at: string,
 *     ended_at: string,
 * }>} online_lesson_ranges
 * @returns {boolean}
 */
const overlaps_online_lesson = (started_at_value, online_lesson_ranges) => {
    const start = new Date(started_at_value)
    // 終了時刻は開始時刻を元に算出
    const end = new Date(start.getTime() + CONSULTATION_MINUTES * 60000)

    return online_lesson_ranges.some((range) => {
        const lesson_start = new Date(range.started_at)
        const lesson_end = new Date(range.ended_at)

        return start < lesson_end && end > lesson_start
    })
}

/**
 * 面談日程入力欄に、対面指導日程と重複していることを示すアラート色（赤枠）を付与/解除する
 *
 * @param {HTMLInputElement} input
 * @param {boolean} is_overlapping
 * @returns {void}
 */
const toggle_overlap_alert = (input, is_overlapping) => {
    OVERLAP_ALERT_CLASSES.forEach((css_class) => input.classList.toggle(css_class, is_overlapping))
}

/**
 * モーダル初期化
 *
 * 「設定」ボタン押下時、対面指導日程と重複する日時であればアラート表示＋入力欄をアラート色にし、
 * 送信を行わない。重複していなければアラート色を解除し、確認モーダル（はい／戻る）を表示する。
 * 「はい」押下時のみ対象フォームをサーバーへ送信する。
 *
 * @param {Array<{
 *     started_at: string,
 *     ended_at: string,
 * }>} online_lesson_ranges
 * @returns {void}
 */
const init_confirm_modal = (online_lesson_ranges) => {
    // モーダル
    const confirm_modal = document.getElementById('career-consultation-schedule-confirm-modal')
    // 「はい」ボタン
    const confirm_yes_btn = document.getElementById('career-consultation-schedule-confirm-yes')
    // 「戻る」ボタン
    const confirm_back_btn = document.getElementById('career-consultation-schedule-confirm-back')
    if (confirm_modal === null || confirm_yes_btn === null || confirm_back_btn === null) return

    let pending_form_id = null

    // 「設定」ボタン押下時イベント定義
    document.querySelectorAll('.js-career-consultation-schedule-submit-btn').forEach((button) => {
        button.addEventListener('click', () => {
            // 送信対象のフォーム
            const form_id = button.getAttribute('data-form-id')
            const form = document.getElementById(form_id)
            if (form === null) return

            // 面談日程が対面指導日程と重複していれば、alert表示する
            const input = form.querySelector('input[type="datetime-local"][name="started_at"]')
            const is_overlapping = input !== null && !!input.value && overlaps_online_lesson(input.value, online_lesson_ranges)
            if (input !== null) toggle_overlap_alert(input, is_overlapping)

            if (is_overlapping) {
                alert('選択した日時は対面指導日程と重複しています。日時を選び直してください。')
                return
            }

            pending_form_id = form_id
            confirm_modal.classList.remove('hidden')
        })
    })

    // 「はい」ボタン押下時イベント定義
    confirm_yes_btn.addEventListener('click', () => {
        const form = pending_form_id !== null ? document.getElementById(pending_form_id) : null
        confirm_modal.classList.add('hidden')
        if (form !== null) form.submit()
    })

    // 「戻る」ボタン押下時イベント定義
    confirm_back_btn.addEventListener('click', () => {
        confirm_modal.classList.add('hidden')
        pending_form_id = null
    })
}

/**
 * 初期化
 *
 * @returns {void}
 */
const init_career_consultation_schedule_edit = () => {
    const ranges_container = document.querySelector('[data-online-lesson-ranges]')
    if (ranges_container === null) return

    const online_lesson_ranges = parse_online_lesson_ranges(ranges_container)

    init_confirm_modal(online_lesson_ranges)
}

document.addEventListener('DOMContentLoaded', init_career_consultation_schedule_edit)
